"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// pax step is valid if a cabinCategory or, if PREMIUM, a cabin has been chosen
function paxStepValid(_state, getters) {
    return getters['pax/valid'] && getters['cabins/valid'];
}
exports.default = paxStepValid;
//# sourceMappingURL=pax_step_valid.js.map